/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import AppLayout from "../../../components/Layout";
import { isModuleApproved } from "../../../routes/ModuleRouter";
import Redirect from "../../../components/Redirect";
import { hasModule } from "../../../constants/user";
import NotFound from "../../../components/NotFound";

const dashboardPaths = [
  '/app/pme',
  '/app/pme/',
];

function PME({ authentication: { user, match }, retrived }) {
  const location = useLocation();
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (location) {
      if (dashboardPaths.includes(location.pathname || '')) {
        setDisabled(!retrived);
      } else if (disabled) {
        setDisabled(false);
      }
    }
  }, [location, retrived]);


  if (user && !isModuleApproved(user, 'pme') && !location.pathname === '/app/pme/profile') {
    return <Redirect to="/app/pme/profiles?create" />
  }

  if (hasModule(user, 'pme')) {
    return <AppLayout
      match={match}
      module="pme"
      disabledSelects={disabled}
      // onCollapse={(val) => setSidebarCollapsed(val)}
    />
  }

  return <NotFound />;
}

export default connect(({ authentication, dashboard }) => ({ authentication, retrived: dashboard.pme.retrived }))(PME);
